import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  textField: {
    marginBottom: theme.spacing(2),
  },
  fileInput: {
    '& input[type="file"]': {
      display: 'none',
    },
  },
  fileTextField: {
    position: 'relative',
    display: 'block',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: 4,
    padding: '16px 14px 8px',
    cursor: 'pointer',
    transition: 'border-color 0.2s',
    minHeight: 24,
    '&:hover': {
      borderColor: 'rgba(0, 0, 0, 0.87)',
    },
  },
  fileTextFieldLabel: {
    position: 'absolute',
    top: -8,
    left: 12,
    backgroundColor: 'white',
    padding: '0 4px',
    fontSize: '0.75rem',
    color: 'rgba(0, 0, 0, 0.6)',
    pointerEvents: 'none',
  },
  fileTextFieldValue: {
    fontSize: '1rem',
    color: 'rgba(0, 0, 0, 0.87)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  fileTextFieldPlaceholder: {
    fontSize: '1rem',
    color: 'rgba(0, 0, 0, 0.42)',
    display: 'block',
  },
  statusCard: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.light,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
  },
  statusItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
  },
  saveButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  expirationWarning: {
    color: theme.palette.warning.main,
    fontWeight: 'bold',
  },
  expirationOk: {
    color: theme.palette.success.main,
  },
}));
